import {
  AritaBuri,
  GmarketSans,
  LinearBeam,
  NanumDaSiSiJagHae,
  NanumHandWritingDaughter,
  Pretendard,
  SpoqaHanSans,
} from './fonts';

export const fontFace = `
    ${Pretendard}
    ${SpoqaHanSans}
    ${NanumHandWritingDaughter}
    ${AritaBuri}
    ${GmarketSans}
    ${NanumDaSiSiJagHae}
    ${LinearBeam}
`;
